import { setShowClientSiteModal } from '../../../State/showClientSiteModal';

export default () => (dispatch) => {

  dispatch(setShowClientSiteModal(true));

}